module.exports = __webpack_public_path__ + "img/home-cropped.741df273.jpg";